import Room from './Room';
import Image from './Image';
import Message from './Message';
import Game from './Game';
import gaLog from '@/utils/ga';

export interface Action {

    run(quiet:boolean):void;

}


// Actions: open/show/open


export class ActionRoom implements Action {

    room: Room;
    action: string;

    constructor(room:Room, action:string){

        this.room = room;
        this.action = action;

    }

    run(quiet: boolean){

        //console.log(this.action);
        //console.log(this.room);

        switch(this.action){
            case 'open':
                this.room.status = 'open';
                break;
        }

    }

}


export class ActionMsg implements Action {

    msg: Message;

    constructor(text_or_msg:string|Message){

        if(text_or_msg instanceof Message){
            this.msg = text_or_msg;
            return;
        }

        this.msg = new Message();
        this.msg.add(text_or_msg);
    }

    run(quiet: boolean){
        if(quiet) return;
        Message.show(this.msg);
    }

}


export class ActionMove implements Action {

    room: Room;

    constructor(room: Room){

        this.room = room;
    }

    run(quiet: boolean){
        
        (async () => {

            const game = await Game.current();
            game!.changeRoom(this.room);

        })();
        

    }

}




export class ActionMarkUsed implements Action {

    item: Image;

    constructor(item: Image){

        this.item = item;

    }

    run(quiet: boolean){

        this.item.used = true;
    }

}


export class ActionPoints implements Action {

    points = 0;
    used = false;

    constructor(points: number){
        
        this.points = points;

    }

    run(quiet: boolean){

        if(this.used) return;

        (async () => {

            const game = await Game.current();
            game!.points += this.points;

            this.used = true;

        })();
        
    }

}


export class ActionLink implements Action {

    url: string;

    constructor(url: string){

        this.url = url;

    }

    run(quiet: boolean){

        if(quiet) return;

        window.open(this.url,'_blank');
        
    }

}

export class ActionEndGame implements Action {


    run(quiet: boolean){

        if(!quiet){
            (async () => {

                const game = await Game.current();
                gaLog('end-game', {
                    points: game?.points,
                    time: game?.getElapsedMinutes(),
                });  

            })();

        }

        console.log("action end gammme");

        (async () => {

            const game = await Game.current();
            game!.finish();

        })();
        
    }

}
